import React from 'react';
import PointAdjust from "../containers/PointAdjust/PointAdjust";

export const PointAdjustPage: React.FC = () => <PointAdjust />;

